// extracted by mini-css-extract-plugin
export default {"viewFeatureStepOuterBox":"ViewFeatureStep_viewFeatureStepOuterBox__mQOdt","viewFeatureStepInnerBox":"ViewFeatureStep_viewFeatureStepInnerBox__at71S"};